import UnlockUserContainer from '../../../../Componant/OtherPages/Authentication/UnlockUser/UnlockUser'

const UnlockUser = () => {
  return (
    <div className='page-body'>
      <UnlockUserContainer />
    </div>
  )
}

export default UnlockUser
